import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import appQrImage from '~/images/appQrCode.png';
import storeQrImage from '~/images/storeQrCode.png';

export interface IProfessionalsTabProps {
  /**
   * `signup` (default): QR opens the App Store / Google Play to download GoTu.
   * `login`: QR deep-links into the installed GoTu app for account access.
   */
  variant?: 'signup' | 'login';
}

const COPY = {
  signup:
    'Scan this QR code with your phone to open the App Store or Google Play and download the GoTu app.',
  login: 'Scan this QR code with your phone to open the GoTu app and access your account.',
} as const;

const TITLE = {
  signup: 'Welcome, Professionals!',
  login: 'Welcome Back, Professionals!',
} as const;

const IMAGES = {
  signup: { src: storeQrImage, alt: 'QR code to download the GoTu mobile app' },
  login: { src: appQrImage, alt: 'QR code to open the GoTu mobile app' },
} as const;

export const ProfessionalsTab = ({ variant = 'signup' }: IProfessionalsTabProps = {}) => {
  const { src, alt } = IMAGES[variant];

  return (
    <div data-testid="professionals-tab">
      <Typography bold color={colors.primary[500]} style={{ fontSize: 28, marginTop: 27 }}>
        {TITLE[variant]}
      </Typography>
      <Row align="start" gap={5} wrap="nowrap" style={{ marginTop: 49 }}>
        {/* DS Typography drops inline maxWidth — wrapper enforces the cap. */}
        <div style={{ maxWidth: 239, marginLeft: 40 }}>
          <Typography size="body_large" color={colors.neutral[500]} style={{ lineHeight: 1.4 }}>
            {COPY[variant]}
          </Typography>
        </div>
        <img
          src={src}
          alt={alt}
          width={90}
          height={90}
          style={{ flexShrink: 0, mixBlendMode: 'multiply' }}
        />
      </Row>
    </div>
  );
};
